import { render, staticRenderFns } from "./tranfer.vue?vue&type=template&id=e7854714"
import script from "./tranfer.vue?vue&type=script&lang=js"
export * from "./tranfer.vue?vue&type=script&lang=js"
import style0 from "./tranfer.vue?vue&type=style&index=0&id=e7854714&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports